<template>
  <div class="page page--appointment-needed">
    <div class="container">
      <div>
        <div class="page-subtitle">Our advice to you</div>
        <h1 class="ascenti">You should book an appointment with a physio</h1>
        <div class="page-copy">
            <p>Based on what you’ve told us, it sounds like physio is suitable for your injury.</p>
            <p>Pick an appointment type that suits you best. If you book right away, we’ll share your answers with your physio so they can give you the best treatment.</p>
        </div>

<!--        <div class="voucher-code">-->
<!--          <img class="voucher-code__icon" src="../assets/img/icons/tag.svg" alt="" />-->
<!--          <p class="voucher-code__copy">Use code CHECKER in the checkout for £5 off your first appointment</p>-->
<!--        </div>-->
      </div>

      <div class="cta-container">
        <div class="cta">
          <h2>Visit a Clinic</h2>
          <p class="cta__copy">Personal consultation with one of our expert physios, in a clinic near you.</p>
          <div class="cta__bullet">
            <img src="../assets/img/icons/map-pointer.svg" alt="" />
            <p>Over 250 clinics nationwide</p>
          </div>
          <div class="cta__bullet">
            <img src="../assets/img/icons/medical.svg" alt="" />
            <p>30 minute consultation to create a personal treatment plan. <a href="https://www.ascenti.co.uk/article/online-physio-treatment" target="_blank">Read more</a></p>
          </div>

          <a href="https://booking.ascenti.co.uk" class="button button--blue">Book now</a>
        </div>

        <div class="cta">
          <h2>See a physio online</h2>
          <p class="cta__copy">Online consultations with our expert physios that fit around your work or lifestyle.</p>
          <div class="cta__bullet">
            <img src="../assets/img/icons/screens.svg" alt="" />
            <p>Use your computer or smart phone wherever you are</p>
          </div>

          <div class="cta__bullet">
            <img src="../assets/img/icons/medical.svg" alt="" />
            <p>30 minute consultation to create a personal treatment plan. <a href="https://www.ascenti.co.uk/article/online-physio-treatment" target="_blank">Read more</a></p>
          </div>

          <a :href="bookingVideoUrl" class="button button--blue">Book now</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentNeeded",

  computed: {
    bookingVideoUrl() {
      return `${process.env.VUE_APP_BOOKING_URL}/video`;
    },
  },

  mounted() {
    this.goToStartIfSurveyNotComplete();
    this.$gtm.trackView('Appointment needed', '/next-step');

    this.setCurrentStep(null);

    this.setSurveyComplete(true);

    this.setNeedsAppointment(true);

    this.clearAnswers();

    this.setBodyPart(null);

    this.scrollToTop();
  },
}
</script>

<style lang="scss">
  .page--appointment-needed {
    .container {
      color: $color-dove-gray;
      display: flex;
      flex-wrap: wrap;
      font-size: 20px;
      line-height: 25px;

      @include screen(md) {
        flex-wrap: nowrap;
      }

      > div {
        flex-basis: 100%;

        &:nth-child(1) {
          @include screen(md) {
            margin-right: 40px;    
          }
        }

        &:nth-child(2) {
          @include screen(md) {
            margin-left: 40px;    
          }
        }
      }

      .page-subtitle {
        font-size: 16px;
        line-height: 37px;
      }

      h1 {
        margin-bottom: 43px;
      }

      .page-copy {
        margin-bottom: 40px;

        p {
          margin-bottom: 30px;
        }
      }

      .voucher-code {
        position: relative;
        background: $color-aqua-haze;
        color: $color-chathams-blue;
        padding: 44px 35px 20px 73px;
        margin-bottom: 40px;

        @include screen(md) {
          max-width: 410px;
          margin-bottom: 0;
        }

        &__icon {
          position: absolute;
          top: 22px;
          left: 22px;
        }
      }

      .cta-container {
        display: flex;
        flex-wrap: wrap;

        @include screen(lg) {
          flex-wrap: nowrap;
        }
      };

      .cta {
        align-self: flex-start;
        background: $color-aqua-haze;
        flex-basis: 100%;
        padding: 30px 23px;
        margin-bottom: 40px;

        @include screen(lg) {
          margin-bottom: 0;
        }

        &:nth-child(1) {
          @include screen(lg) {
            margin-right: 10px;
          }
        }

        &:nth-child(2) {
          @include screen(lg) {
            margin-left: 10px;
          }
        }

        h2 {
          font-size: 30px;
          color: $color-chathams-blue;
          margin-bottom: 20px;
        }

        p {
          color: $color-chathams-blue;
        }

        &__bullet {        
          display: flex;
          margin-bottom: 20px;

          img {
            margin-right: 13px;
            align-self: flex-start;
            margin-top: 5px;
          }

          p {
            font-size: 16px;
            color: $color-dove-gray;
            margin: 0;

            a {
              color: $color-dove-gray;
            }
          }
        }

        .button {
          margin: 20px auto 0 auto;
          min-width: 0;
          width: 100%;
          max-width: 300px;
          display: block;
        }
      }
    }
  }

</style>
